

module.exports = {
  "table-of-contents":   {
    "table-of-contents": () => import("../table-of-contents/table-of-contents.js")
  }
}